import { IApkType, IParametersOfApkType } from 'types';

export const apkTypes: IApkType[] = [
	{ apkTypeID: 1, apkTypeName: 'Business' },
	{ apkTypeID: 2, apkTypeName: 'Payment' },
	{ apkTypeID: 3, apkTypeName: 'OTA' },
	{ apkTypeID: 4, apkTypeName: 'Launcher' },
];

export const extraApkTypes: IApkType[] = [
	{ apkTypeID: 5, apkTypeName: 'VivaWallet' },
	{ apkTypeID: 6, apkTypeName: 'M4 Bank' },
	{ apkTypeID: 7, apkTypeName: 'TBank' },
	{ apkTypeID: 8, apkTypeName: '2Can' },
];

export const allApkTypes = [...apkTypes, ...extraApkTypes];

export const parametersOfApkType: IParametersOfApkType[] = [
	{ parametersOfApkTypeID: 'main', parametersOfApkTypeName: 'mainApkType' },
	{ parametersOfApkTypeID: 'extra', parametersOfApkTypeName: 'extraApkType' },
];

export const mainApps = [
	{ id: 'Business', name: 'Business application' },
	{ id: 'Payment', name: 'Payment service' },
	{ id: 'OTA', name: 'OTA' },
	{ id: 'Launcher', name: 'Launcher' },
];
